import React from 'react';
import { MapPin, Clock } from 'lucide-react';
import { GymInfo } from '../../../types/dashboard';

interface GymOverviewProps {
  gymInfo: GymInfo | null;
  isLoading?: boolean;
}

const GymOverview: React.FC<GymOverviewProps> = ({ gymInfo, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
        <div className="h-5 bg-gray-800 rounded w-32 mb-4 animate-pulse" />
        <div className="space-y-3">
          <div className="h-4 bg-gray-800 rounded w-48 animate-pulse" />
          <div className="h-4 bg-gray-800 rounded w-40 animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
      <h3 className="text-white text-lg font-semibold mb-4">Gym Overview</h3>
      
      <div className="space-y-3">
        <div>
          <p className="text-gray-400 text-sm mb-1">Gym Name</p>
          <p className="text-white font-medium">
            {gymInfo?.name || 'Not available'}
          </p>
        </div>
        
        <div className="flex items-start space-x-2">
          <MapPin size={16} className="text-[#23F47C] mt-1" />
          <div>
            <p className="text-gray-400 text-sm mb-1">Location</p>
            <p className="text-white font-medium">
              {gymInfo?.location || 'Not available'}
            </p>
          </div>
        </div>
        
        <div className="flex items-start space-x-2">
          <Clock size={16} className="text-[#23F47C] mt-1" />
          <div>
            <p className="text-gray-400 text-sm mb-1">Timezone</p>
            <p className="text-white font-medium">
              {gymInfo?.timezone || 'Not available'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GymOverview;
